import { BottomBar } from '@pages/Trips/CreateTripFlow/core/presentation'
import { canLeaveWhatStep, eventName } from '../../EventCreateFlow/core/draft'
import { EventCreateStep, nextStep } from '../../EventCreateFlow/core/presentation'
import { EventEditState, hasChanges } from './editState'

/**
 * The edit-event flow's bottom bar. The steps, their indicator and pages are
 * the create flow's (`EventCreateFlow/core/presentation`); only the button
 * differs. Mirrors Android's `EditEventPresentation`.
 */

/** Only the last step saves. */
export const editCtaTitle = (step: EventCreateStep): string => (nextStep(step) ? 'Next' : 'Save')

/**
 * The event as edited over its day. Next needs a name, as creating does; Save
 * also needs something to save — the edit always commits, as
 * edit-destinations' does, so there's nothing to send for an untouched event.
 */
export const editBottomBar = (state: EventEditState, step: EventCreateStep, day: string): BottomBar => ({
	title: eventName(state.draft) || 'Edit Event',
	subtitle: day,
	ctaTitle: editCtaTitle(step),
	ctaStyle: 'primary',
	ctaEnabled: canLeaveWhatStep(state.draft) && (nextStep(step) !== null || hasChanges(state)),
	showsBack: false,
})
